import clsx from 'clsx';
import React__default, { useState, useEffect } from 'react';

/* eslint-disable react/self-closing-comp */
const Checkbox = ({ children, checked = false, disabled = false, inline = false, onChange, ...inputProps }) => {
    const [checkedState, setCheckedState] = useState(checked);
    useEffect(() => setCheckedState(checked), [checked]);
    const handleOnChange = (e) => {
        if (!disabled) {
            setCheckedState(!checkedState);
            if (onChange)
                onChange(e);
        }
    };
    return (React__default.createElement("label", { className: clsx({
            'c-checkbox': true,
            'c-checkbox--inline': inline,
            'c-checkbox--disabled': disabled
        }) },
        children,
        React__default.createElement("input", { ...inputProps, type: 'checkbox', checked: checkedState, disabled: disabled, onChange: handleOnChange }),
        React__default.createElement("span", { className: 'c-checkmark' })));
};

export { Checkbox };
//# sourceMappingURL=index.js.map
